var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTickBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "15px",
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icTick") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Inbox---Search-/-Filter",
    transform: "translate(-337.000000, -313.000000)",
    fill: "#478bf1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000000, 158.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(9.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tick",
    transform: "translate(318.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Page-1",
    points: "15.1549294 -0.000133732748 6.35498021 9.42802503 2.68702525 6.00747566 0 8.88975072 6.54755537 15 18.0372045 2.68956617"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTickBlue);
export default __webpack_public_path__ + "static/media/icTickBlue.94c65e6caeb8cda903f983174079600d.svg";
export { ForwardRef as ReactComponent };